import { render, staticRenderFns } from "./fvFooter.vue?vue&type=template&id=343501b4&lang=pug&"
var script = {}
import style0 from "./fvFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvFooter.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvFooter.vue
// module id = 94
// module chunks = 0 1